import Button from '@material-ui/core/Button';
import MobileStepper from '@material-ui/core/MobileStepper';
import React, { Component } from 'react';
import styled from 'styled-components';

import Steps from './Steps';

const StyledCarousel = styled.div`

    & .stolo-carousel-slide {
       max-height: 80vh;
       display: flex;
       align-items: center;
    }

    & .stolo-carousel-container {
       display: block;
       margin-right: auto;
       margin-left: auto;
       overflow: hidden;
       max-width: 100%;
       max-height: 100%;
       text-align: center;
       
       & img {
         max-height: 70vh;
         object-fit: contain;
         overflow: hidden;
       }
    }

     

    & .stolo-carousel-heading {
       color: ${props => props.theme.palette.primary.dark};
       background-color: ${props => props.theme.palette.secondary[100]};
       height: 3em;
       display: flex;
       align-items: center;
       
       & p {
         margin: ${props => props.theme.space[3]} auto;
       }
    }
    
    & .stolo-carousel-stepper {
        background-color: ${props => props.theme.palette.secondary[100]};
        color: ${props => props.theme.palette.primary.dark};
    }
    
    & .stolo-carousel-stepper-dot {
        background-color: ${props => props.theme.palette.secondary[200]};
    }
    
     & .stolo-carousel-stepper-dot-active {
        background-color: ${props => props.theme.palette.secondary[700]};
    }
    
`;


class Carousel extends Component {

    static Steps = Steps;

    state = {
        activeStep: this.props.activeStep || 0,
    };

    handleStepChange = activeStep => {
        this.setState({ activeStep });
    };

    handleNext = () => {
        this.setState(prevState => {
            if (prevState.activeStep < this.props.maxSteps) {
                return Object.assign(
                    {}, this.state, { activeStep: prevState.activeStep + 1 });
            }
            return Object.assign({}, this.state, { activeStep: 0 });
        });
    };

    handleBack = () => {
        this.setState(prevState => {
            if (prevState.activeStep - 1 < 0) {
                return Object.assign(
                    {}, this.state, { activeStep: this.props.maxSteps });
            }
            return Object.assign(
                {}, this.state, { activeStep: prevState.activeStep - 1 });
        });
    };

    render() {
        const { state, handleStepChange, maxSteps } = this;
        const { activeStep } = state;
        return (
            <StyledCarousel>
                {this.props.children(activeStep, handleStepChange)}
                <MobileStepper
                    variant='dots'
                    steps={this.props.maxSteps + 1}
                    position='static'
                    activeStep={activeStep}
                    className='stolo-carousel-stepper'
                    classes={{
                        dot: 'stolo-carousel-stepper-dot',
                        dotActive: 'stolo-carousel-stepper-dot-active',
                    }}
                    nextButton={<Button
                        size='small' onClick={this.handleNext}
                    >
                        Next
                    </Button>}
                    backButton={<Button
                        size='small' onClick={this.handleBack}
                    >
                        Back
                    </Button>}
                />
            </StyledCarousel>
        );
    }
}


export default Carousel;



// WEBPACK FOOTER //
// ./src/components/stepper/Carousel.js